/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
/**
 * mixer for different Navigators
 */
export class MixNavigator {
    /**
     * constructor
     * @param factories factories of the Navigators to use
     */
    constructor(navigators) {
        this._navigators = navigators;
    }
    /**
     * see interface
     */
    dispose() {
        this._navigators.forEach((n) => n.dispose());
    }
    /**
     * see interface
     */
    update() {
        this._navigators.forEach((n) => n.update());
    }
    /**
     * see interface
     */
    enable(enable) {
        this._navigators.forEach((n) => n.enable(enable));
    }
}
//# sourceMappingURL=MixNavigator.js.map